var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C28.1412 0 36 7.42887 36 17.4606C36 27.4924 28.1394 34.9213 18 34.9213C16.24 34.9235 14.4876 34.691 12.789 34.23C12.47 34.1423 12.1306 34.1671 11.8278 34.3002L8.2548 35.8771C8.03903 35.9725 7.80314 36.0134 7.56787 35.9962C7.3326 35.979 7.10515 35.9043 6.90552 35.7786C6.70589 35.6529 6.54019 35.4801 6.42299 35.2754C6.3058 35.0706 6.24069 34.8403 6.2334 34.6045L6.1362 31.4003C6.12917 31.2054 6.08263 31.014 5.9994 30.8376C5.91617 30.6613 5.79798 30.5036 5.652 30.3743C2.151 27.2422 0 22.7096 0 17.4606C0 7.42887 7.8588 0 18 0ZM7.191 22.5674C6.6834 23.372 7.6734 24.2793 8.4312 23.7033L14.1102 19.3939C14.2976 19.2524 14.5261 19.1759 14.7609 19.1759C14.9957 19.1759 15.2242 19.2524 15.4116 19.3939L19.6164 22.544C19.9148 22.7682 20.2565 22.928 20.6198 23.0134C20.9831 23.0988 21.3602 23.108 21.7272 23.0404C22.0943 22.9727 22.4433 22.8297 22.7523 22.6203C23.0613 22.411 23.3235 22.1398 23.5224 21.824L28.809 13.4357C29.3166 12.6293 28.3266 11.722 27.5688 12.2962L21.8898 16.6092C21.7024 16.7507 21.4739 16.8272 21.2391 16.8272C21.0043 16.8272 20.7758 16.7507 20.5884 16.6092L16.3818 13.4591C16.0834 13.2353 15.7419 13.0757 15.3788 12.9904C15.0156 12.9052 14.6388 12.8961 14.272 12.9637C13.9051 13.0314 13.5563 13.1743 13.2475 13.3835C12.9387 13.5927 12.6765 13.8636 12.4776 14.1791L7.191 22.5674Z",
    fill: "url(#paint0_linear_657_96226)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_657_96226",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5280"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMessenger);
export default __webpack_public_path__ + "static/media/facebook-messenger.137e16e2038b58043fa0f93d9cf7b8a9.svg";
export { ForwardRef as ReactComponent };